import { render, staticRenderFns } from "./kcgl.vue?vue&type=template&id=299eb6b3&scoped=true&"
import script from "./kcgl.vue?vue&type=script&lang=js&"
export * from "./kcgl.vue?vue&type=script&lang=js&"
import style0 from "./kcgl.vue?vue&type=style&index=0&id=299eb6b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299eb6b3",
  null
  
)

export default component.exports